import { useEffect, useState, useRef } from 'react';
import 'chartjs-adapter-moment';
import 'hammerjs' 
import LazyChart from './lazychart';

export default function WinGraph(props) {
    const [data, setdata] = useState({ options: {}, graphdata: { datasets: [] } });
    const chartRef = useRef(null);
    const handleResetZoom = () => {
        if (chartRef && chartRef.current) {
            chartRef.current.resetZoom();
        }
    };

    useEffect(() => {
        if (props.windata) {
            var winObj = props.windata;
            var label = winObj.tsX;
            var data1 = winObj.x;
            var data2 = winObj.y;
            var data3 = winObj.z;

            let data = {
                labels: label,
                datasets:
                    [
                        {
                            label: "X",
                            type: "line",
                            data: data1,
                            borderColor: "#383838",
                            backgroundColor: "#383838",
                            borderWidth: 0.8,
                            pointRadius: 0,
                            yAxisID: 'y',
                        },
                        {
                            label: "Y",
                            type: "line",
                            data: data2,
                            borderColor: "#6e6e6e",
                            backgroundColor: "#6e6e6e",
                            borderWidth: 0.8,
                            pointRadius: 0,
                            yAxisID: 'y',
                        },
                        {
                            label: "Z",
                            type: "line",
                            data: data3,
                            borderColor: "#d9d9d9",
                            backgroundColor: "#d9d9d9",
                            borderWidth: 0.8,
                            pointRadius: 0,
                            yAxisID: 'y',
                        },
                    ],
            };

            let options = {
                animation: false,
                maintainAspectRatio: false,
                responsive: true,
                scales: {
                    x: {
                        type: 'time',
                        time: {
                          unit: 'second',
                          stepSize: 5,
                          displayFormats: {
                              'second': 'mm:ss'
                          }
                        },
                        scaleLabel: {
                            display: true,
                        },
                        ticks: {
                            autoSkip: true,
                            autoSkipPadding: 20,
                            maxRotation: 0,
                            minRotation: 0
                        }
                    },
                    y: {
                        display: true,
                        position: 'left',
                        min: -props.maxval,
                        max: props.maxval,
                        ticks: {
                            display: true,
                        },
                        title: {
                            display: true,
                            text: props.unit,
                          },
                    },
                },
                plugins: {
                    zoom: {
                        pan: {
                            enabled: true,
                            mode: 'xy',
                            scaleMode: 'xy',
                            modifierKey: "ctrl",
                        },
                        zoom: {
                            wheel: {
                                enabled: false,
                            },
                            pinch: {
                                enabled: true,
                            },
                            drag: {
                                enabled: true,
                            },
                            mode: "xy",
                            scaleMode: "xy",
                     
                        }
                    },
                    legend: {
                        position: "right",
                        labels: {
                            boxWidth: 10,
                        },
                    },  
                }
            };
            setdata({ options: options, graphdata: data });
        }
    }
    , [props.windata])

    return (
        <div style={{ height: props.height, position:"relative" }} onDoubleClick={handleResetZoom}>
            <LazyChart
                ref={chartRef}
                data={data.graphdata}
                options={data.options}
                height={props.height}
            />
            <div style={{position: "absolute", right:"0.5em", bottom:"0.125em", fontSize:"small"}}>(時刻)</div>
        </div>
    );
}
